import React, { useState, useEffect } from 'react';
import Topbar from '../../component/Topbar';
import SideMenu from '../../component/SideMenu';
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const NotificationList = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const userToken = localStorage.getItem('userToken');

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseurl}getUserNotifications`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });

      if (response.data && response.data.notifications) {
        setNotifications(response.data.notifications);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAsRead = async (id) => {
    try {
      const res = await axios.post(`${baseurl}markNotificationRead`, 
        { notificationId: id, markAll: false }, 
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      if (res.data.success) {
        // Update local state immediately for better UX
        setNotifications(prev => 
          prev.map(n => n.id === id ? { ...n, is_read: true } : n)
        );
      }
    } catch (err) {
      console.error("Error marking as read:", err);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const getIcon = (iconName) => {
    switch (iconName?.toLowerCase()) {
      case 'settings': return <i className="fas fa-cog"></i>;
      case 'project': return <i className="fas fa-file-invoice"></i>;
      case 'alert': return <i className="fas fa-exclamation-circle"></i>;
      case 'system_alert': return <i className="fas fa-shield-alt"></i>;
      default: return <i className="fas fa-bell"></i>;
    }
  };

  return (
    <div className="app-container">
      <Topbar />
      <div className="main-wrapper" style={{ background: '#F4F7FE', display: 'flex' }}>
        <SideMenu />

        <div className="profile-content-container p-4" style={{ flex: 1, overflow: 'auto' }}>
         

          <div className='page-title-section mb-3'>
              <h1>Activity Timeline</h1>
              <p className='page-subtitle' >Stay updated with your latest property project activities</p>
            </div>



          <div className="timeline-container">
            {loading ? (
              [...Array(5)].map((_, i) => (
                <div key={i} className="timeline-item">
                  <div className="timeline-icon-wrapper skeleton-icon"></div>
                  <div className="timeline-content">
                    <Skeleton width={150} height={20} className="mb-2" />
                    <Skeleton count={2} />
                  </div>
                </div>
              ))
            ) : notifications.length === 0 ? (
              <div className="empty-state shadow-sm">
                <i className="fas fa-bell-slash mb-3 fa-2x"></i>
                <p>No recent activities found.</p>
              </div>
            ) : (
              notifications.map((notif) => (
                <div 
                  key={notif.id} 
                  className={`timeline-item ${!notif.is_read ? 'unread-item' : 'read-item'}`}
                  onClick={() => !notif.is_read && handleMarkAsRead(notif.id)}
                >
                  <div className={`timeline-icon-wrapper priority-${notif.priority?.toLowerCase()}`}>
                    {getIcon(notif.icon)}
                  </div>
                  
                  <div className="timeline-content shadow-sm">
                    <div className="timeline-header">
                      <div className="d-flex align-items-center">
                        <h3 className="notif-title">{notif.title}</h3>
                        {!notif.is_read && <span className="new-badge">New</span>}
                      </div>
                      <span className="notif-time">{formatTime(notif.created_at)}</span>
                    </div>
                    <p className="notif-message">{notif.message}</p>
                    
                    <div className="timeline-footer">
                      {/* {notif.link_url && (
                        <a href={notif.link_url} className="notif-link" onClick={(e) => e.stopPropagation()}>
                          Details <i className="fas fa-external-link-alt ms-1"></i>
                        </a>
                      )} */}
                      {!notif.is_read && (
                        <span className="mark-hint">Click to mark as read</span>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <style>{`
        .timeline-container {
          position: relative;
          max-width: 850px;
          margin: 0 auto;
        }

        .timeline-item {
          display: flex;
          gap: 20px;
          position: relative;
          padding-bottom: 35px;
          cursor: pointer;
        }

        /* The vertical line */
        .timeline-item:not(:last-child)::after {
          content: '';
          position: absolute;
          left: 22px;
          top: 50px;
          bottom: 0;
          width: 2px;
          background: #DDE2EF;
        }

        .timeline-icon-wrapper {
          width: 46px;
          height: 46px;
          min-width: 46px;
          border-radius: 12px; /* Square-ish rounded look */
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
          color: #4a5568;
          border: 2px solid transparent;
          transition: all 0.3s ease;
        }

        .priority-low { background: #f8fafc; color: #64748b; border-color: #e2e8f0; }
        .priority-medium { background: #eff6ff; color: #3b82f6; border-color: #dbeafe; }
        .priority-high { background: #fff1f2; color: #e11d48; border-color: #ffe4e6; }

        .timeline-content {
          background: #fff;
          padding: 18px 22px;
          border-radius: 16px;
          flex: 1;
          border: 1px solid #edf2f7;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        /* Unread State Style */
        .unread-item .timeline-content {
          border-left: 6px solid #4361ee;
          background: linear-gradient(to right, #f8faff, #ffffff);
        }

        .unread-item:hover .timeline-content {
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(67, 97, 238, 0.08) !important;
        }

        /* Read State Style */
        .read-item {
          opacity: 0.85;
        }

        .new-badge {
          background: #4361ee;
          color: white;
          font-size: 10px;
          padding: 2px 8px;
          border-radius: 20px;
          margin-left: 10px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          font-weight: 700;
        }

        .timeline-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }

        .notif-title {
          font-size: 16px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
        }

        .notif-time {
          font-size: 11px;
          font-weight: 500;
          color: #94a3b8;
        }

        .notif-message {
          font-size: 14px;
          color: #475569;
          line-height: 1.5;
          margin-bottom: 12px;
        }

        .timeline-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .notif-link {
          font-size: 13px;
          color: #4361ee;
          text-decoration: none;
          font-weight: 600;
        }

        .mark-hint {
          font-size: 11px;
          color: #94a3b8;
          font-style: italic;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .unread-item:hover .mark-hint {
          opacity: 1;
        }

        .empty-state {
          text-align: center;
          padding: 80px 20px;
          color: #94a3b8;
          background: #fff;
          border-radius: 24px;
        }

        .skeleton-icon { background: #e2e8f0; border: none; }
      `}</style>
    </div>
  );
};

export default NotificationList;